import React, { useEffect, useState } from 'react';
import leftarrow from '../../../assets/repayment/leftarrow.svg';
import SingleMandateCard from '../components/single-mandate-card';
import FullScreenBackdropLoader from '../../../fibe-ui/full-screen-backdrop-loader';
import getMandatesListAPICall from '../helpers/get-mandate-list';
import { useAuthStore } from '../../../redux';
import { useNavigate } from 'react-router';

const MandateListComponent = () => {
  const navigate = useNavigate();

  const { customerId, customerRefNum, Authorization } = useAuthStore();
  const [autopayListToRender, setAutopayListToRender] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getMandatesListAPICallLocal = () => {
    setIsLoading(true);
    getMandatesListAPICall({
      customerCredentials: {
        customerId,
        customerRefNum,
        Authorization,
      },
      payload: {
        customerRefNum,
      },
      successFn: (res) => {
        const { statusCode, statusDes, statusMsg, body } = res;
        if (statusCode == 200) {
          const { autopayList } = body;
          console.log('autopayList: ', autopayList);
          setAutopayListToRender([...autopayList]);
        }
      },
      errorFn: (err) => {
        console.log('Error: ', err);
      },
      finallyFn: () => {
        setIsLoading(false);
      },
    });
  };

  useEffect(() => {
    getMandatesListAPICallLocal();
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event) {
      history.pushState(null, document.title, location.href);
    });
  }, []);

  const moveToReasonsScreen = () => {
    navigate('/nach-cancellation/reason');
  };

  const backButtonClickHandler = () => {
    navigate('/dashboard');
  };

  return (
    <>
      {/* ReasonForMandateCancellation */}
      <FullScreenBackdropLoader isLoading={isLoading} />
      <div className="p-0 lg:p-6">
        <div className="flex items-center mb-0 lg:mb-5 p-4 lg:p-0 shadow-md lg:shadow-none">
          <img
            onClick={backButtonClickHandler}
            className="inline-block mr-4 w-[11px] hover:cursor-pointer"
            src={leftarrow}
            alt="leftarrow"
          />
          <span className="text-text-primary text-xl md:text-xl">
            Auto Debit
          </span>
        </div>

        <div className="p-4 lg:p-0 mt-4 lg:mt-0">
          <div className="rounded-2xl border border-stroke px-2 py-5 lg:px-8 lg:py-7">
            <div className="text-text-primary text-lg lg:text-xl pl-4 lg:pl-0">
              Following mandates will be cancelled
            </div>

            <div className="mt-5">
              <div className="grid gap-7 grid-cols-1 grid-rows-1 lg:grid-cols-2 p-4 lg:p-0">
                {autopayListToRender?.length > 0
                  ? autopayListToRender.map((singleMandateData) => (
                      <SingleMandateCard
                        singleMandateData={singleMandateData}
                      />
                    ))
                  : 'No active mandates to show'}
              </div>
            </div>

            <div className="p-4 lg:p-0 mt-6 lg:mt-10">
              <div>
                <button
                  onClick={moveToReasonsScreen}
                  className="bg-accent hover:bg-teal-600 ease-out duration-500 transition-all text-base border border-accent text-white font-medium p-3 text-center rounded-md shadow-md w-full lg:w-[190px] mr-0 lg:mr-4 mb-3 lg:mb-0 "
                >
                  Proceed to cancel
                </button>

                <button
                  onClick={backButtonClickHandler}
                  className="bg-white text-base text-accent hover:bg-teal-100 ease-out duration-500 transition-all border border-accent font-medium p-3 text-center rounded-md shadow-md w-full lg:w-[190px] mr-0 lg:mr-4 mb-3 lg:mb-0"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MandateListComponent;
